import React, { useEffect } from 'react'
import i18n from 'live/services/i18n'
import { PackageFeatureResource } from '../http/api'

const FeatureLabel: React.VFC<{ feature: PackageFeatureResource; isUnpacked?: boolean }> = ({
    feature,
    isUnpacked = false
}) => {
    const label = feature.label || feature.name
    const url = feature.installed?.entityMapping?.url

    return (
        <>
            <span title={feature.uuid}>{label}</span>
            {feature.version ? <i className="version">v{feature.version}</i> : null}
            {url ? (
                <>
                    <a href={url} target="_blank">
                        <i className="fa fa-external-link"></i>
                    </a>
                </>
            ) : (
                <i title={i18n('Link only available when installed')} className="fa fa-external-link disabled"></i>
            )}

            {/* {isUnpacked && (
                <a style={{ color: 'var(--red-500)', cursor: 'auto' }}>
                    <i className="fas fa-box-open break" />
                </a>
            )} */}
        </>
    )
}

export default FeatureLabel
